import { LegalLayout, Section, SubHead, Bullets } from '../components/LegalLayout';
import { BRAND } from '../lib/constants';

export default function TermsConditions() {
  return (
    <LegalLayout
      title={<>Terms &amp; <span className="italic text-[#a465a8]">Conditions</span>.</>}
      effective="01 February 2026"
      testId="terms-conditions-page"
      intro={<>Welcome to <strong>Find Your MUA</strong>. By accessing or using our Platform, you agree to comply with these Terms &amp; Conditions.</>}
    >
      <Section n="01" title="Nature of Services">
        <p>Find Your MUA is a <strong>beauty artist discovery and booking platform</strong>. We connect clients with carefully vetted and curated makeup artists. We act solely as an intermediary platform and do not directly provide beauty services.</p>
      </Section>

      <Section n="02" title="Eligibility">
        <p>Users must be at least <strong>18 years old</strong> or have legal guardian consent.</p>
      </Section>

      <Section n="03" title="Booking & Payment Terms">
        <p>To confirm a booking:</p>
        <SubHead>Payment Schedule</SubHead>
        <p><strong>1. Booking Fee</strong> — A <strong>10% booking fee</strong> must be paid via the Platform to secure the booking request.</p>
        <p><strong>2. Second Payment</strong> — <strong>40% payment</strong> must be completed within <strong>30 days of booking confirmation</strong>.</p>
        <p><strong>3. Final Payment</strong> — Remaining <strong>50% payment</strong> shall be paid <strong>on the day of the event</strong> directly to the artist unless otherwise agreed.</p>
        <p>Failure to complete payment may result in cancellation.</p>
      </Section>

      <Section n="04" title="Artist Matching">
        <p>We make reasonable efforts to connect users with suitable artists. However, artist selection remains the client's responsibility.</p>
        <p>We do not guarantee:</p>
        <Bullets items={['Specific outcomes', 'Satisfaction', 'Artist availability', 'Compatibility', 'Exact makeup results']} />
      </Section>

      <Section n="05" title="Artist Responsibility">
        <p>Artists remain independent service providers. All:</p>
        <Bullets items={['Services', 'Conduct', 'Communication', 'Timeliness', 'Hygiene', 'Product choices']} />
        <p>remain solely the responsibility of the artist.</p>
      </Section>

      <Section n="06" title="Platform Responsibility">
        <p>Find Your MUA acts only as a facilitator. We are not liable for:</p>
        <Bullets items={['Makeup outcomes', 'Delays', 'Service dissatisfaction', 'Misconduct', 'Allergic reactions', 'Product-related issues', 'Artist cancellations', 'Missed appointments']} />
      </Section>

      <Section n="07" title="Travel & Venue Charges">
        <p>Travel charges may apply based on artist location and venue. Accommodation and food arrangements (if required for destination or venue makeup) shall be borne by the client.</p>
      </Section>

      <Section n="08" title="Trial Makeup">
        <p>Bridal trial availability depends on artist policies and package selection.</p>
      </Section>

      <Section n="09" title="Rescheduling">
        <p>Rescheduling requests are subject to:</p>
        <Bullets items={['Artist availability', 'Advance notice']} />
        <p>Additional charges may apply.</p>
      </Section>

      <Section n="10" title="Cancellations">
        <p>Cancellation terms shall be governed by our <strong>Refund &amp; Cancellation Policy</strong>.</p>
      </Section>

      <Section n="11" title="No Chargebacks">
        <p>Users agree not to initiate unauthorized payment reversals or chargebacks. Any disputes should first be raised with Find Your MUA support.</p>
      </Section>

      <Section n="12" title="Intellectual Property">
        <p>All content on Find Your MUA including:</p>
        <Bullets items={['Logos', 'Designs', 'Images', 'Branding', 'Website content']} />
        <p>is protected and may not be copied without permission.</p>
      </Section>

      <Section n="13" title="Suspension & Termination">
        <p>We reserve the right to suspend or terminate accounts if users:</p>
        <Bullets items={['Abuse the platform', 'Misuse services', 'Harass artists', 'Submit false information', 'Violate policies']} />
      </Section>

      <Section n="14" title="Limitation of Liability">
        <p>To the maximum extent permitted by law, Find Your MUA shall not be liable for:</p>
        <Bullets items={['Indirect losses', 'Lost opportunities', 'Emotional distress', 'Financial damages', 'Third-party disputes']} />
        <p>Our maximum liability shall not exceed the amount paid through the Platform.</p>
      </Section>

      <Section n="15" title="Governing Law">
        <p>These Terms shall be governed by the laws of India. Any disputes shall be subject to the jurisdiction of <strong>New Delhi, India</strong>.</p>
      </Section>

      <Section n="16" title="Contact">
        <p>For support: <a href={`mailto:${BRAND.email}`} className="text-[#eb5381] underline">{BRAND.email}</a></p>
      </Section>
    </LegalLayout>
  );
}
